import Vue from 'vue';
import {auth,firestore} from '@/firebase.js';

export default {
  state:{
    id:null,
    uid:null,
    displayName:'',
    email:'',
    photoURL:'',
    perfil:{
      id:null,
      nombre:'',
      permisos:{
        vacantes:{
            consultar:false,
            agregar:false,
            editar:false,
            eliminar:false
        },
        empresas:{
            consultar:false,
            agregar:false,
            editar:false,
            eliminar:false
        },
        usuarios:{
            consultar:false,
            agregar:false,
            editar:false,
            eliminar:false
        },
        perfiles:{
            consultar:false,
            agregar:false,
            editar:false,
            eliminar:false
        },
        tarjeta:{
            consultar:false,
            editar:false
        },
        chat:{
            consultar:false,
            contestar:false
        },
        plantilla:{
            consultar:false,
            editar:false
        },
      }
    },
    cliente:{
      id:null,
      nombre:''
    }
  },
  mutations: {
    setUsuario(state,user){
      state.id=user.id;
      state.uid=user.uid;
      state.displayName=user.displayName;
      state.email=user.email;
      state.photoURL=user.photoURL;
      state.perfil=user.perfil;
      state.cliente=user.cliente;
    }
  },
  actions: { 
    ActualizarUsuario(context){
      var user = auth.currentUser;
      if (user!=null) {
        firestore.collection('usuarios')
        .where('uid','==',user.uid)
        .where('estatus','==',1)
        .get()
        .then(querySnapshot=>{
          let dato = null;
          querySnapshot.forEach(doc=>{
            dato=doc.data();
            dato.id=doc.id;
          })
          if (dato!=null) {
            context.commit('setUsuario',dato);    
          }else{
            swal('Tu usuario ya no existe','','error');
            auth.signOut();
          }
        })
        .catch(error=>{
          console.log(error);
          swal('Problemas para consultar tu información de usuario','Favor de intentarlo mas tarde','error');
          auth.signOut();
        });
      }else{
        context.commit('setUsuario',{
          id:null,
          uid:null,
          displayName:'',
          email:'',
          photoURL:'',
          perfil:{
            id:null,
            nombre:'',
            permisos:[]
          },
          cliente:{
            id:null,
            nombre:''
          }
        });
      }
      
    },
  },
  getters: {  
    
  }
}


// WEBPACK FOOTER //
// ./src/modules/usuario.js